import Moment from 'moment'

export function dateToLocale (inputDate) {
  let dateTime = Moment(inputDate).toDate()
  dateTime = new Date(dateTime)
  dateTime = dateTime.setHours(dateTime.getHours() - 3)
  dateTime = new Date(dateTime)
  const date = dateTime.toLocaleDateString()
  let time = Moment(dateTime).format('HH:mm')
  return date + ' às ' + time
}

export function formatDate (value, yearDigits = 2) {
  let formattedDate = ''
  if (value) {
    let date = Moment(value).utc()
    if (date.isValid()) {
      let day = ('0' + date.date()).slice(-2)
      let month = ('0' + (date.month() + 1)).slice(-2)
      let year = String(date.year())
      year = yearDigits === 2 ? year.substring(2, 4) : year
      let dateString = day + '/' + month + '/' + year
      formattedDate = dateString
    }
  }

  return formattedDate
}

export function formartDateFromArray (value) {
  return value.day + '/' + value.month + '/' + value.year
}

export function getCustomDateLabel(startDate, endDate) {
  const today = formatDate(new Date(), 4);
  const startDateFormatted = formatDate(startDate, 4);
  const endDateFormatted = formatDate(endDate, 4);

  if (!startDateFormatted && !endDateFormatted) {
    return null;
  }

  if (startDateFormatted === endDateFormatted) {
    return startDateFormatted === today ? 'Hoje' : startDateFormatted;
  }

  return `${startDateFormatted} - ${endDateFormatted}`;
}

